// extracted by mini-css-extract-plugin
export default {"Emojify":"bbi_a bhh_g"};